import { createSelector } from 'reselect';
import commonSelector, { selectedCustomerIdSelector } from '@store/common/selectors';
import metricsChartContainerSelector from '@store/metricsChartContainer/selectors';
import comparisonSelector from '@store/summaryContainer/comparison/selectors';
import summaryStoreSelector from '@store/summaryContainer/selectors';
import { selector as birdChartSelector } from '@store/common/birdChart';
import { selector as dimensionContainerSelector } from '@store/dimensionContainer';
import viewerSessionsSelector from '@store/viewerSessions/selectors';
import { selectedAiAlertSelector } from '@store/trends/aiAlerts/selectors';
import { summaryWidgetsSelector } from '@store/summaryWidgets/selector';
import { SUMMARY_PANEL_TYPE } from '@components/top-widget-panel/constants';
import alertStateSelector from '../alerts/selectors';
import { birdChartSharedSelector as viewerDrillDownBirdChartSelector } from '../birdChart/selectors';
import distributionSelector from '../distribution/selectors';
import { trendsBaseSharingSelector } from '../base/selectors';
import { isAppModule } from '@utils/constants';

export const sharingSelector = createSelector(
  commonSelector as any,
  comparisonSelector,
  summaryWidgetsSelector,
  metricsChartContainerSelector,
  dimensionContainerSelector,
  birdChartSelector,
  viewerDrillDownBirdChartSelector,
  viewerSessionsSelector,
  summaryStoreSelector,
  selectedCustomerIdSelector,
  distributionSelector,
  alertStateSelector,
  selectedAiAlertSelector,
  trendsBaseSharingSelector,
  (
    commonStore,
    comparisonStore,
    summaryWidgets,
    metricsChartContainerStore,
    dimensionContainerStore,
    birdChartStore,
    viewerDrillDownBirdChart,
    viewerSessionsStore,
    summaryContainer,
    selectedCustomerId,
    distribution,
    alertState,
    selectedAiAlert,
    trendsBase,
  ) => {
    const dashboard = isAppModule ? 'app-experience' : 'trends';
    const { interval, appliedFilters, filterColor, tzOffset, collapseStatus, dod, layout } =
      commonStore;
    const { interval: comparisonInterval } = comparisonStore;
    const { showDiagChart } = dimensionContainerStore;
    const { selectedMetrics, dataType } = viewerSessionsStore.trends;
    const { sliceFrom, sliceTo, lastSliceFrom, lastSliceTo, lastSliderFrom, lastSliderTo } =
      birdChartStore;
    const drilldownData = summaryContainer.drilldown;
    const start = interval.from;
    const end = interval.to;
    const title = `${'Trends'} ${start} ${end}`;
    return {
      title,
      dashboard,
      start,
      end,
      state: {
        common: {
          appliedFilters,
          interval,
          filterColor,
          tzOffset,
          selectedCustomerId,
          collapseStatus,
          dod,
          layout,
        },
        comparison: {
          interval: comparisonInterval,
        },
        summaryWidgets: {
          type: summaryWidgets.type || SUMMARY_PANEL_TYPE.SPI,
          widgets: summaryWidgets.widgets,
        },
        // new trends layout
        metricsChartContainer: {
          metric: metricsChartContainerStore.metric,
          metrics: metricsChartContainerStore.metrics,
        },
        dimensionContainer: {
          showDiagChart,
        },
        birdChart: {
          sliceFrom,
          sliceTo,
          lastSliceFrom,
          lastSliceTo,
          lastSliderFrom,
          lastSliderTo,
        },
        viewerDrillDownBirdChart,
        summary: {
          drilldownData,
        },
        viewerSessionsTable: {
          selectedMetrics,
          dataType,
        },
        selectedAiAlert,
        distribution,
        'module:trends': {
          alerts: alertState,
          selectedAiAlert,
          base: trendsBase,
        },
      },
    };
  },
);
